<template>
  <v-dialog v-model="show" width="500px">
    <ModalContentSubBukuBesarTahun :onclose="close" />
  </v-dialog>
</template>

<script>
import ModalContentSubBukuBesarTahun from './ModalContentSubBukuBesarTahun.vue';

export default {
  data() {
    return {
      show: false,
    };
  },
  components: {
    ModalContentSubBukuBesarTahun,
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
  },
};
</script>
